// src/utils/http.ts
/**
 * Get a query parameter by name from the URL.
 * @param key The query parameter name.
 */
export function getQueryParam(key) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
}
/**
 * Get a token from cookies by name.
 * @param cookieName The name of the cookie (default: 'token').
 */
export function getTokenFromCookies(cookieName = 'token') {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) {
            return decodeURIComponent(value);
        }
    }
    return null;
}
/**
 * Fetch wrapper that includes Bearer token from cookies in the Authorization header.
 * @param url The request URL.
 * @param options Fetch options.
 */
export async function fetchWithAuth(url, options = {}) {
    const token = getTokenFromCookies();
    options.headers = {
        ...options.headers,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            console.error(`HTTP Error: ${response.status} ${response.statusText}`);
            if (response.status === 401) {
                // 🔐 Redirect to login or error page
                window.location.href = '/'; // or '/login'
                return Promise.reject(new Error('Unauthorized'));
            }
            throw new Error(`Request failed with status ${response.status}`);
        }
        return response;
    }
    catch (error) {
        console.error('Fetch with Auth failed:', error);
        throw error;
    }
}
